// @TODO: ADD THIS TO ENV
export const MARKETING_HOST = 'https://www.gethearth.com';
export const DISPLAY_HOST = 'www.GetHearth.com';
export const SIGNUP_HOST = 'https://signup.gethearth.com';
export const SIGNUP_FINANCING_HOST = 'https://signup.gethearth.com/contractors/fast-customer-financing';
